import { Box, List, ListItem, Unstable_Grid2 as Grid, TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Toolbar, Typography, Button, Checkbox, IconButton, TableFooter, TablePagination, TextField, TableSortLabel } from "@mui/material";
import { DataField, DataRow, DropdownModel, MasterListDataOutput, MasterListItem } from "../../../data/interfaces/sharedmodels";
import masterlistService from "../../../data/api/masterlist.service";
import { useEffect, useState } from "react";
import Masterlistcreate from "./masterlistcreate";
import EditIcon from '@mui/icons-material/Edit';
import CreateStationForm from "./createstationform";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";


export default function MasterListCommonTable({ listType, excludedCodes, asLookup, callback }:
    { listType: DropdownModel, excludedCodes: string[], asLookup: boolean, callback: any }) {

    const [items, setItems] = useState<MasterListDataOutput | null>(null);
    const [backbutton, setbackbutton] = useState<boolean>(true);
    const [fieldDatatype, setfieldDatatype] = useState<MasterListDataOutput | null>(null);
    const [dataRow, setdataRow] = useState<DataRow | undefined>();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [filteredItems, setFilteredItems] = useState<MasterListDataOutput | null>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc" | undefined>("asc");
    const [sortField, setSortField] = useState<string | null>(null);

    useEffect(() => {
        masterlistService.getItems(Number.parseInt(listType.Id)).then((response) => {
            setItems(response.data);
            setFilteredItems(response.data);
        })
    }, [listType]);

    useEffect(() => {
        if (items) {
            const filtered = items.Rows.filter((row) =>
                row.Attributes.some((att) =>items.FieldLookups.findIndex(a=>a.FieldName==att.Name)>-1?items.FieldLookups.filter(a=>a.FieldName==att.Name)[0].LookUpValues.filter(v=>v.Id==att.Value)[0].Description.toLowerCase().includes(searchQuery.toLowerCase())
              :(att.Value??"").toString().toLowerCase().includes(searchQuery.toLowerCase()))
            );
            setFilteredItems({ ...items, Rows: filtered });
        }
    }, [searchQuery, items]);

    const handleSort = (fieldName: string) => {
        const isAsc = sortField === fieldName && sortOrder === "asc";
        setSortOrder(isAsc ? "desc" : "asc");
        setSortField(fieldName);
        const sortedRows = [...filteredItems?.Rows ?? []].sort((a, b) => {
            const aValue = a.Attributes.find((att) => att.Name === fieldName)?.Value || "";
            const bValue = b.Attributes.find((att) => att.Name === fieldName)?.Value || "";
            return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
        });
        setFilteredItems(filteredItems ? { ...filteredItems, Rows: sortedRows } : null);
    };
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (items && items.Rows ? items.Rows.length : 0)) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleCheckChange = (event: any, row: DataRow) => {
        callback(event.target.checked, row);
    }
    const callbackupdatelisttype = (masterlistid: string) => {
        masterlistService.getItems(Number.parseInt(masterlistid)).then((response) => {
            setItems(response.data);
        })
    }
    const handlebackclick = () => {
        callback(null);
    }

    const handleItemClick = (
        fieldDatatype: MasterListDataOutput | null, row?: DataRow
    ) => {
        setdataRow(row);
        if (fieldDatatype == null) {
            setbackbutton(true);
        } else {
            setbackbutton(false);
        }

        setfieldDatatype(fieldDatatype);

    };

    //console.log(items);
    return (
        <Box sx={{ bgcolor: '#fff' }}>

            {fieldDatatype ? listType.Id == "7" ? <CreateStationForm callbackupdatelisttype={callbackupdatelisttype} id={dataRow?.UniqueIdValue} cancel={handleItemClick} /> :
                <Masterlistcreate datarow={dataRow} listType={listType} fieldtype={fieldDatatype} cancel={handleItemClick} callbackupdatelisttype={callbackupdatelisttype} /> :
                <Box>
                    <Toolbar>
                        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between'}}>
                            <Typography variant="h6">
                                {listType.Description}
                                {(items?.CanAddRows || items?.IsEditable) ? null : "(Read Only)"}
                            </Typography>
                            <Box sx={{display:'flex'}}>
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    sx={{ mr: 1 }}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {backbutton ? <Button variant="outlined" color="primary" onClick={() => handlebackclick()}>Back</Button> : null}
                                {items?.CanAddRows ? <Button sx={{ ml: 1 }} variant="contained" onClick={(event) => handleItemClick(items, undefined)}>Create New</Button> : null}
                            </Box>
                        </Box>
                    </Toolbar>
                    <TableContainer >
                        <Table size="small" >
                            <TableHead>

                                <TableRow>

                                    {asLookup ? <TableCell>Select</TableCell> : null

                                    }

                                    {items?.Fields.filter(a => a.IsBrowsable).map((field, index2) => {
                                        return (
                                            <TableCell key={field.Name} onClick={() => handleSort(field.Name)} sx={{cursor:'pointer'}}>
                                                
                                                {field.Description}
                                                <TableSortLabel
                                                    active={sortField === field.Name}
                                                    direction={sortField === field.Name ? sortOrder : "asc"}
                                                    
                                                ></TableSortLabel>
                                            </TableCell>
                                        )
                                    })}
                                    {items?.IsEditable ? <TableCell>Edit</TableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {filteredItems && filteredItems.Rows ?
                                    (rowsPerPage > 0
                                        ? filteredItems.Rows.filter(a => excludedCodes.findIndex(b => b == a.UniqueIdValue.toString()) < 0).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : filteredItems.Rows.filter(a => excludedCodes.findIndex(b => b == a.UniqueIdValue.toString()) < 0)).map((row, index) => {
                                            return (
                                                <TableRow key={row.UniqueIdValue + '_' + index}>

                                                    {asLookup ?
                                                        <TableCell padding="checkbox">
                                                            <Checkbox onChange={(event) => handleCheckChange(event, row)}
                                                                color="primary"
                                                            />
                                                        </TableCell> : null

                                                    }

                                                    {row.Attributes.filter(a => filteredItems.Fields.filter(b => b.Name == a.Name)[0].IsBrowsable).map((att, indexatt) => {
                                                        var fieldLookups = filteredItems.FieldLookups.filter(a => a.FieldName == att.Name);
                                                        return (
                                                            <TableCell key={att.Name + row.UniqueIdValue + indexatt}>{fieldLookups.length > 0 && fieldLookups[0].LookUpValues.filter(a => a.Id == att.Value).length > 0 ? fieldLookups[0].LookUpValues.filter(a => a.Id == att.Value)[0].Description : att.Value}</TableCell>
                                                        )

                                                    })}
                                                    {

                                                        items?.IsEditable ?
                                                            <TableCell><IconButton sx={{ fontSize: 18, p: 0 }} onClick={(event) => handleItemClick(items, row)} > <EditIcon /> </IconButton> </TableCell> : null
                                                    }
                                                </TableRow>

                                            )
                                        })
                                    : null}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        sx={{
                                            "& .MuiTablePagination-spacer": {
                                                order: 2
                                            }
                                        }}

                                        rowsPerPageOptions={[15, 20, 30, 40, 50, { label: 'All', value: -1 }]}
                                        count={filteredItems && filteredItems.Rows ? filteredItems.Rows.filter(a => excludedCodes.findIndex(b => b == a.UniqueIdValue.toString()) < 0 && !a.IsDeleted).length : 0}
                                        rowsPerPage={rowsPerPage}
                                        showFirstButton={true}
                                        showLastButton={true}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {
                                                'aria-label': 'rows per page'

                                            }
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Box>
            }
        </Box>

    )
}